module.exports = __webpack_public_path__ + "img/ISSO-rafting-Atlanta-2018-summer-RP_27.c3478788.webp";